import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneModal from "../../../../Components/OneModal/OneModal"
import { Typography } from "@mui/material"
import OneTextArea from "../../../../Components/OneTextArea/OneTextArea"

const ModalInfoImovel = ({ imovel, open, setOpen }) => {
    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText="Informações do imóvel"
        >
            <Grid container sx={container1}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography>Bloco: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.unidade1}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Apartamento: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.unidade2}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Prefixo Ramal: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.telefone}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Ramal: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.ramal}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Telefone: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.telefone}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Vagas Garagem: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.vagas_garagem}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Vagas Disponíveis: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.vagas_disponiveis}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Observações: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <OneTextArea
                                name="observacoes"
                                defaultValue={imovel.observacao}
                                readOnly={true}
                                // onChange={handleChange}
                                newSx={textAreaSx}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default ModalInfoImovel

const container1 = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '20px'
}
const formGroupTextValue = {
    fontWeight: 'bold'

}
const textAreaSx = {
    height: '100px',
    width: '100%'
}
